import { Component, Prop, h } from '@stencil/core';
import { Menu } from '../../../navigation-structure.models';

@Component({
    tag: 'pnl-navigation-sub-menu',
})
export class NavigationSubMenu {
    @Prop() menu: Menu;
    @Prop() renderedIndex: string;

    render() {
        return (
            <div class="pnl-navigation__sublist-wrapper">
                <div class="pnl-navigation__sublist">
                    <ul
                        id={
                            'pnl-navigation-sub-menu-container' +
                            this.renderedIndex
                        }
                        class="pnl-navigation__list-wrapper"
                    >
                        {this.menu.items.map((subItem) => (
                            <li class="pnl-navigation__item pnl-navigation__sub-item">
                                <a
                                    class="pnl-navigation__link"
                                    href={subItem.link}
                                >
                                    <span class="pnl-navigation__link-txt">
                                        {subItem.title}
                                    </span>
                                </a>
                            </li>
                        ))}
                    </ul>
                    {this.menu.quicklinks.length > 0 && (
                        <ul class="pnl-navigation__list-wrapper pnl-navigation__list-wrapper--row">
                            {this.menu.quicklinks.map((qlItem) => (
                                <li class="pnl-navigation__item pnl-navigation__sub-item pnl-navigation__sub-item--block">
                                    <a
                                        class="pnl-navigation__link"
                                        href={qlItem.link}
                                    >
                                        <span class="pnl-navigation__link-txt">
                                            {qlItem.title}
                                        </span>
                                        <img
                                            class="pnl-navigation__link-img"
                                            src={qlItem.image}
                                            alt=""
                                        />
                                    </a>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        );
    }
}
